<template>
  <div class="antv-chart-mini">
    <div class="chart-wrapper" :style="{ height: 46 }">
      <v-chart :force-fit="true" :height="height" :data="chartData" :scale="scale" :padding="[36, 0, 18, 0]">
        <v-tooltip :show="showTip" :shared="false" :hideMarkers="false" title="x" />
        <v-smooth-line
          v-if="type == 'lineArea'"
          position="x*y"
          :size="2"
          color="rgba(24,144,255,1)"
        />
        <v-smooth-area :onMouseMove="handleHover" position="x*y" :color="color"/>
      </v-chart>
    </div>
  </div>
</template>

<script>
import moment from "moment";
const tooltip = [
    'x*y',
    (x, y) => ({
        name: x,
        value: y
    })
];

export default {
  name: "MiniArea",
  props: {
    type: {
      type: String,
      default: "area",
    },
    color: {
      type: String,
      default: "#1890FF",
    },
    tipAlias: {
      type: String,
      default: "y",
    },
    showTip: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Array,
      default: () => [
        {
          x: 1,
          y: 2,
          z: 3
        },
      ],
    },
  },
  data() {
    return {
      tooltip,
      scale: [{
          dataKey: 'x',
      }, {
          dataKey: 'y',
          alias: this.tipAlias,
      }],
      height: 88,
      tempData: [{ x: "2020-08-20", y: 2 }],
    };
  },
  methods: {
    handleHover(e, chart) {
      // console.log('点数据',e, e.data, e.x, e.target._cfg.box.width);
      if(this.showTip == false) {
        // 点间距
        let distance = e.target._cfg.box.width / e.data.length;
        // 根据点击x轴位置，选择对应的数据
        let pointIndex = ~~(e.x / distance);
        let showInfo = e.data[pointIndex]._origin;
        this.$emit('cardInfo',showInfo)
      }
    }
  },
};
</script>

<style lang="scss">
.g2-tooltip {
  display: none;
}
@import "chart";
</style>
